import { Dialog as MuiDialog, Grid, Typography, Box } from '@mui/material';
import { SystemStyleObject, Theme } from '@mui/system';
import { IDialogContent, IDialogFooter, IDialogHeader, IDialog } from './types';
import { styles } from './styles';

export const Dialog = ({ children, sx, ...rest }: IDialog) => {
  return (
    <MuiDialog sx={styles.dialog(sx)} {...rest}>
      {children}
    </MuiDialog>
  );
};

const Header = ({ heading, subheading, sx, headingAddon, children }: IDialogHeader) => {
  return (
    <Grid sx={[styles.header, sx as SystemStyleObject<Theme>]}>
      <Grid sx={styles.headerText}>
        <Grid sx={styles.headerContent}>
          <Box sx={styles.heading}>{heading}</Box>
          {headingAddon}
        </Grid>
        {subheading && <Box sx={styles.subheading}>{subheading}</Box>}
      </Grid>
      {children}
    </Grid>
  );
};

const Content = ({ sx, children }: IDialogContent) => {
  return <Grid sx={[styles.content, sx as SystemStyleObject<Theme>]}>{children}</Grid>;
};

const Footer = ({ sx, children }: IDialogFooter) => {
  return <Grid sx={[styles.footer, sx as SystemStyleObject<Theme>]}>{children}</Grid>;
};

Dialog.Header = Header;
Dialog.Content = Content;
Dialog.Footer = Footer;
